module.exports = __webpack_public_path__ + "img/henry-ford.366deadd.png";